import { render, staticRenderFns } from "./FixedBottomRightArea.vue?vue&type=template&id=143fc620&scoped=true&"
import script from "./FixedBottomRightArea.vue?vue&type=script&lang=js&"
export * from "./FixedBottomRightArea.vue?vue&type=script&lang=js&"
import style0 from "./FixedBottomRightArea.vue?vue&type=style&index=0&id=143fc620&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "143fc620",
  null
  
)

export default component.exports